import {
  IChangePasswordRequest,
  ILoginResponse,
  ILoginSocial,
  INormalLogin,
  IRegisterRequest,
  IResetPassword,
} from "../interfaces/auth.interface.ts";
import { createService } from "../../factory/service-factory.ts";

/**
 * Service for authentication-related API calls
 * Refactored to use the service-factory for better error handling and request cancellation
 */
export default function authService() {
  // Create a base service for auth endpoints
  const authBaseService = createService("/auth");

  const postLoginSocial = async (
    data: ILoginSocial
  ): Promise<ILoginResponse> => {
    return await authBaseService.customPost<ILoginResponse>("/social-login", data);
  };

  const postLogin = async (dataSend: INormalLogin): Promise<ILoginResponse> => {
    return await authBaseService.customPost<ILoginResponse>("/login", dataSend);
  };

  const postRegister = async (
    data: IRegisterRequest
  ): Promise<ILoginResponse> => {
    return await authBaseService.customPost<ILoginResponse>("/register", data);
  };

  const postChangePassword = async (
    data: IChangePasswordRequest
  ): Promise<void> => {
    return await authBaseService.customPost<void>("/change-password", data);
  };

  const postResetPassword = async (data: IResetPassword): Promise<void> => {
    return await authBaseService.customPost<void>("/reset-password", data);
  };

  return {
    postLoginSocial,
    postLogin,
    postRegister,
    postChangePassword,
    postResetPassword,
  };
}
